var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 3.99999H12.6666M6.99996 7.99999H12.6666M6.99996 12H12.6666M4.83329 3.99999C4.83329 4.18408 4.68405 4.33332 4.49996 4.33332C4.31586 4.33332 4.16663 4.18408 4.16663 3.99999C4.16663 3.81589 4.31586 3.66666 4.49996 3.66666C4.68405 3.66666 4.83329 3.81589 4.83329 3.99999ZM4.83329 7.99999C4.83329 8.18408 4.68405 8.33332 4.49996 8.33332C4.31586 8.33332 4.16663 8.18408 4.16663 7.99999C4.16663 7.81589 4.31586 7.66666 4.49996 7.66666C4.68405 7.66666 4.83329 7.81589 4.83329 7.99999ZM4.83329 12C4.83329 12.1841 4.68405 12.3333 4.49996 12.3333C4.31586 12.3333 4.16663 12.1841 4.16663 12C4.16663 11.8159 4.31586 11.6667 4.49996 11.6667C4.68405 11.6667 4.83329 11.8159 4.83329 12Z",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unorderedList.e2b77440b96043c27f5aaf2de713050a.svg";
export { ForwardRef as ReactComponent };